import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/** Reference total: "1" (back) = 0, A=1, J=11, Q=12, K=13, else the rank number */
const cardPoints = (card) => {
  if (!card || card === "1") return 0;
  let v = card.length === 4 ? card.slice(0, 2) : card.slice(0, 1);
  if (v === "J") v = 11;
  if (v === "Q") v = 12;
  if (v === "K") v = 13;
  if (v === "A") v = 1;
  return parseInt(v, 10) || 0;
};

/**
 * Mogambo video overlay — reference markup (casino-table.mogambo):
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *     (.race-total, Daga/Teja 2 cards, Mogambo 1 card)
 * The .casino-video-title is MogamboVideoTitle, passed to VideoBox as titleNode.
 */
export default function MogamboCardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  const cards = String(card ?? "").split(",");
  const total = cards.reduce((sum, c) => sum + cardPoints(c), 0);

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const toggleCards = () => {
    if (cards[0] !== "1") setShowCards((s) => !s);
  };

  return (
    <div className={`casino-video-cards${!showCards || cards[0] === "1" ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={toggleCards}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <div className="race-total">Total: {total}</div>{" "}
        <div>
          <span className="mr-2">Daga/Teja</span>{" "}
          <span>
            <CardImg src={getCardImage(cards[0])} alt="" />
          </span>{" "}
          <span>
            <CardImg src={getCardImage(cards[1])} alt="" />
          </span>
        </div>{" "}
        <div className="text-center">
          <span className="mr-2">Mogambo</span>{" "}
          <span>
            <CardImg src={getCardImage(cards[2])} alt="" />
          </span>
        </div>
      </div>
    </div>
  );
}
